import { render, staticRenderFns } from "./approve-modal.vue?vue&type=template&id=5176a880&scoped=true&"
import script from "./approve-modal.vue?vue&type=script&lang=js&"
export * from "./approve-modal.vue?vue&type=script&lang=js&"
import style0 from "./approve-modal.vue?vue&type=style&index=0&id=5176a880&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5176a880",
  null
  
)

export default component.exports